import { GroupNode } from '.';
import React from 'react';
import './styles.scss';

export const RootTree = ({
  onSelect,
  selectedId,
  rootGroups,
  getChildren,
  getCameras,
  groupMap,
  onSelectCamera,
  getIsExpanded,
  onExpand,
  getShouldScrollAfterLoad,
  getIsCameraSelected,
  getIsCameraPinned,
  onPinCamera,
  className,
}) => {
  const onNodeSelect = (groupId) => {
    onSelect(groupMap.current[groupId]);
  };

  return (
    <div id="live-root-tree" className={className}>
      <div className="root-group-list">
        {rootGroups?.map((group) => (
          <GroupNode
            key={group.id}
            id={group.id}
            name={group.name}
            getChildren={getChildren}
            getIsSelected={(id) => id === selectedId}
            isParentSelected={false}
            getIsExpanded={getIsExpanded}
            onSelect={onNodeSelect}
            onExpand={onExpand}
            level={0}
            getCameras={getCameras}
            onSelectCamera={onSelectCamera}
            getShouldScrollAfterLoad={getShouldScrollAfterLoad}
            getIsCameraSelected={getIsCameraSelected}
            getIsCameraPinned={getIsCameraPinned}
            onPinCamera={onPinCamera}
            filterChildren={filterChildren}
          />
        ))}
      </div>
    </div>
  );
};

const filterChildren = () => true;
